import React from 'react'
import { FaCheckCircle, FaRegCircle } from 'react-icons/fa'
import { AiOutlineLoading } from 'react-icons/ai'
import { StepState } from '../utils/getStepState'

interface AccordionHeaderProps {
  stepState: StepState
  progress: number
  title: string | React.ReactNode
  subtitle?: string | React.ReactNode
}

const AccordionHeaderContent: React.FC<AccordionHeaderProps> = ({
  stepState,
  progress,
  title,
  subtitle
}) => {
  return (
    <div className="accordion-header-content">
      <div className="accordion-left-section">
        <div className="step-indicator">
          <div className={`step-icon step-icon--${stepState}`}>
            {stepState === 'completed' && <FaCheckCircle />}
            {stepState === 'running' && <AiOutlineLoading className="rotating-icon" />}
            {stepState === 'not-started' && <FaRegCircle />}
          </div>
        </div>
        <div className="step-info">
          <h5 className="step-title mb-0">{title}</h5>
          {subtitle && <p className="step-subtitle mb-0"><b>{subtitle}</b></p>}
        </div>
      </div>
      <div className="accordion-right-section">
        <div className="progress-bar-container">
          <div className="progress-bar-wrapper">
            <div
              className={`progress-bar-fill progress-bar-fill--${stepState}`}
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <span className="progress-text">{progress}%</span>
        </div>
      </div>
    </div>
  )
}

export default AccordionHeaderContent
